import { Breadcrumb as AntdBreadcrumb } from "@empglabs/backoffice-ui-kit"

const Breadcrumb = props => {
  return <AntdBreadcrumb {...props} />
}

export default Breadcrumb
